import React from "react";
import { Button, Container } from "react-bootstrap";
import DataTable from "react-data-table-component";
import { Link } from "react-router-dom";
import AppLoaderTable from "../Apploader/AppLoaderTable";
import TopHeader from "../Common/TopHeader";

type Props = {
    heading: string,
    action: string,
    data: any,
    columns: any,
    subHeaderComponent : any,
    showLoader : boolean,
}

const VendorCommon = ({ heading, action, data, columns , subHeaderComponent, showLoader }: Props) => {

    return (
        <>
            <Container fluid>
                <div className="mt-3">
                    <TopHeader 
                        heading= {heading}
                        to={"/customer/create"}
                        className= "fa-plus"
                        action= {action}
                        id= "add-customer"
                    />

                    <DataTable
                        progressPending={showLoader}
                        progressComponent={<AppLoaderTable />}
                        data={data}
                        columns={columns}
                        pagination
                        paginationRowsPerPageOptions={[5, 10, 15, 20]}
                        highlightOnHover
                        subHeader
                        persistTableHead
                        subHeaderComponent={subHeaderComponent}
                    />

                </div>
            </Container>
        </>
    )
}

export default VendorCommon;